<template>
    <div class="history clear">
        <div class="tb-list_ty1">
            <div class="tb-header clear"> 
                <div class="tb_sort fr">
                  <CommonFilterB 
                    :folderList="folderList" 
                    :filterReset="filterReset" 
                    :filterId="'hisotry'" 
                    :initFilter="initFilter"
                    @updateCommonFilterB="updateCommonFilterB" />
                </div>
            </div><!-- //tb-header -->
        </div><!-- //tb-list_ty1 -->
 
        <div class="nodata" v-if="!historyDates || historyDates.length == 0">
          <div class="inner">
              <div class="txt">
                {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
                </div>
          </div>
          <!-- <div class="inner" v-if="updatedList.length == 0">
              <div class="txt">보드를 등록하여 멤버들과 협업해보세요.</div>
              <button type="button" class="btn-primary-small black" @click="addBoard" :disabled="!loginUserIsInternalUser">보드 추가</button>
          </div> -->
        </div> 
        
        <div class="date_wrap" v-if="historyDates && historyDates.length > 0"> <!--  --> 
          <template v-for="(date , index ) in historyDates" >
            <div class="task_box_day"  :class="currentIndex == index ? '':'active'" :key="'historyDate_'+index" >
              <div class="nodat"></div>
              <div class="day" @click="changeDate(date, index)" 
                   v-if="date.historyDay == $moment().format('YYYY-MM-DD')" :key="'history_'+index">  
                    {{ $i18nUtil.trans("message.DashboardHistory.today","오늘") }}
              </div> 
              <div class="day"  @click="changeDate(date, index)" 
                   v-if="date.historyDay == $moment().subtract(1, 'day').format('YYYY-MM-DD')" :key="'history_'+index">  
                    {{ $i18nUtil.trans("message.DashboardHistory.yesterday","어제") }}
              </div>  
              <div class="day"  @click="changeDate(date, index)" 
                   v-if="date.historyDay < $moment().subtract(1, 'day').format('YYYY-MM-DD')" :key="'history_'+index">    
                  {{$moment(date.historyDay).format('YYYY.MM.DD')}}
              </div> 
              <HistoryData  v-if="currentIndex == index"
                  :updatedList="updatedList"
                  :groupId="groupId"
                  :isSnapshot="false"></HistoryData>
            </div> 
            <div class="btn_box txtc" :key="'historyDateMore_'+index"  v-if="updatedList.length != 0 && currentIndex == index && totalPage > currentPage+1 ">
              <button type="button" class="btn-more-ico_small1 down"
                      @click="moreHistory(date)">
                    {{totalElements-updatedList.length > 10 ? '10':totalElements-updatedList.length}}건 더보기
              </button>
              &nbsp;
            </div>
          </template> 
        </div><!--//date_wrap-->
    </div><!-- //history -->
</template>

<script>
import HistoryData from "./HistoryData";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
//보드 추가 모달
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";
import CommonFilterB from "@/components/cowork/common/filter/CommonFilterB";
export default {
    components: {
      HistoryData,
      CommonFilterB
    },
    props:["loginUserIsInternalUser"],
    data() {
        return {
          groupId : null,
          updatedList:[],

          historyDates:[],
          currentPage:0,
          totalPage:0,
          currentIndex:0,
          totalElements:0,
          moreYn :true,
          noneData : false,

          projectId :null,
          userId :null,
          parentCategoryMid :null,
          projectName :null,
          folderList: [],
          filterReset: false,
          categoryMidList: [],
          gradeCodeList: [],
          statusList: [],

          initFilter:[],

          categoryCheckYn : false,
          gradeCheckYn : false,
          statusCheckYn : false
        };
    }, 
    mounted() {},
    computed: {
      ...mapState("project", ["projectInfo"]), // 현재 정보
    },
    methods : {
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
      ...mapActions("modals", ["showModal"]),
      setGroupId(groupId, projectId, userId, parentCategoryMid, projectName, state){   
        this.groupId = groupId;
        this.projectId = projectId;
        this.userId = userId;
        this.parentCategoryMid = parentCategoryMid;
        this.projectName = projectName;

        this.updatedList=[];

        this.currentPage=0;
        this.totalPage =0;
        this.currentIndex=0;
        this.totalElements =0;
        this.historyDates=[];

        this.initHistoryFolderList();

        if(window.sessionStorage.getItem("moveBoard") === 'true'){
          // window.sessionStorage.setItem("moveBoard",false);
        }else{
          let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
          if(stateArr.length == 0){
            //저장
            stateArr.push(state);
            window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
          }else{
            let lastState = stateArr[stateArr.length-1];
            let localStorageAllListYn  = localStorage.getItem("boardAllListUse");
            if(localStorageAllListYn === "true"){
              if(lastState.currentTab == 0 && lastState.currentTab2 == 3 && lastState.currentTab3 == 0){
                // 같은 탭 누른 경우 .
              }else{
                // 다른 탭에서 누른경우
                stateArr.push(state);
                window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
              }
            }else{
              if(lastState.currentTab == 0 && lastState.currentTab2 == 2 && lastState.currentTab3 == 0){
                // 같은 탭 누른 경우 .
              }else{
                // 다른 탭에서 누른경우
                stateArr.push(state);
                window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
              }
            }
          }
          // if(window.sessionStorage.getItem("prevBtn")  === 'true' ){ 
          //   // 뒤로가기 버튼으로 접근.
          //   let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
          //   stateArr.push(state);
          //   window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
          // }else{
          //   let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
          //   stateArr.push(state);
          //   window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
          // }
        }
      },
      getHistoryDate(groupId){
        let obj = this;
        if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){ 
          let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
          let state = stateArr[stateArr.length-1]; 
          // 필터 유지 .
          obj.categoryMidList = state.categoryMidList;
          obj.gradeCodeList = state.gradeCodeList;
          obj.statusList = state.statusList;

          obj.initFilter = {
            categoryMidList : state.categoryCheckYn ?  obj.categoryMidList : [],
            gradeCodeList : state.gradeCheckYn ? obj.gradeCodeList : [],
            statusList : state.statusCheckYn ? obj.statusList : []
          }
        }

        let reqData = {};
        reqData.params ={
          groupId:groupId,
          categoryMidList: obj.categoryMidList,
          gradeCodeList: obj.gradeCodeList,
          statusCodeList: obj.statusList,
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/history/getDashboardHistoryDayList";
        reqData.method = "post"; 
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => {   
            obj.historyDates = res.result.historyDayList;
            let stateSaveDate = "";
            if(obj.historyDates.length != 0){ 
              if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
                let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
                let state = stateArr[stateArr.length-1]; 
                obj.currentIndex=state.idx;
                if(obj.currentIndex == null){
                  obj.currentIndex = 0;
                  stateSaveDate = obj.historyDates[0];
                  obj.getHistoryByDate(obj.historyDates[0], groupId);
                }else{
                  stateSaveDate = state.date;
                  obj.getHistoryByDate(state.date, groupId);
                }
              }else{
                obj.currentIndex = 0;
                stateSaveDate = obj.historyDates[0];
                obj.getHistoryByDate(obj.historyDates[0], groupId);
              }
            }else{
              obj.noneData=true;
            }

            if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
              window.sessionStorage.setItem("moveBoard",false);
              window.sessionStorage.setItem("prevBtn",false);
            }
            //sessionStorage Update
            let sessionState = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
            if(sessionState.length != 0){
              let lastState = sessionState.pop();
              lastState.date = stateSaveDate;
              lastState.idx = obj.currentIndex; 
              lastState.categoryMidList = obj.categoryMidList;
              lastState.gradeCodeList = obj.gradeCodeList; 
              lastState.statusList = obj.statusList;
              lastState.statusCheckYn = obj.statusCheckYn;
              lastState.categoryCheckYn = obj.categoryCheckYn;
              lastState.gradeCheckYn = obj.gradeCheckYn;
              sessionState.push(lastState);
              window.sessionStorage.setItem("dashboard", JSON.stringify(sessionState));
            }
          })
          .catch(function(err) { console.log(err); });
      },
      getHistoryByDate(date, groupId){
        let obj = this;
        let reqData = {};
        reqData.params ={
          groupId:groupId,
          page:obj.currentPage,
          historyDay:date.historyDay,
          categoryMidList: obj.categoryMidList,
          gradeCodeList: obj.gradeCodeList,
          statusCodeList: obj.statusList,
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/history/getDashboardHistoryListLimit";
        reqData.method = "post"; 
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => {    
            if(obj.currentPage == 0){
              obj.updatedList = [];
            }
            let newData = res.result.historyDayList.content;
            obj.totalElements = res.result.historyDayList.totalElements;
            obj.totalPage = res.result.historyDayList.totalPages;
            if(newData.length != 0){ 
              for(let k in newData){
                obj.updatedList.splice(obj.updatedList.length, 0, newData[k]);
              } 
            }
            if(obj.updatedList.length == 0 ) {
              obj.noneData=true;
            }
          })
          .catch(function(err) { console.log(err); });
      },
      moreHistory(date){
        this.currentPage++;
        this.getHistoryByDate(date, date.groupId);
      },
      initHistoryFolderList() {
        let obj = this;
        let reqData = {};
        reqData.params = {
          projectId: obj.projectId,
        };
        reqData.req = obj.req;
        reqData.url = "/api/copaper/category/getProjectCategoryList";
        reqData.method = "post"; 
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then((res) => {
            obj.folderList = res.result.categoryList.list;
            obj.categoryMidList = [];
            obj.gradeCodeList = [];
            obj.statusList = [];
            obj.filterReset = true;
            setTimeout(()=>{obj.filterReset = false;}, 50);
            obj.getHistoryDate(obj.groupId);
          })
          .catch(function (err) {
            console.log(err);
          });

      },
      changeDate(date, idx){
        if(idx == this.currentIndex) {
          if(!event.target.parentElement.classList.contains("active")) {
            event.target.parentElement.classList.add("active");
            this.moreYn =false;
            this.updatedList = [];
            return;
          } else {
            event.target.parentElement.classList.remove("active");
          }
        }

        this.moreYn =true;
        this.currentIndex = idx;
        this.updatedList = [];
        this.currentPage = 0;
        this.getHistoryByDate(date, date.groupId);
        
        //sessionStorage Update
        
        let sessionState = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];  
        if(sessionState.length != 0){
          let lastState = sessionState.pop();
          lastState.date = date;
          lastState.idx = idx;
          sessionState.push(lastState);
          window.sessionStorage.setItem("dashboard", JSON.stringify(sessionState));
        }
      },
      addBoard(item) { 
        let obj = this;
        let reqData = {};
        reqData.params ={
        }
        reqData.req = obj.req;
        reqData.url = "/api/copaper/paper/getGeneratedPaperId";
        reqData.method = "post";
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => {
            let errorCode = res.errorCode;
            let addPaperId = res.result;
            const modalInfo = {
              title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
              name: "registBoard",
              method: "post",
              width: "800px",
              // height: "493px",
              obj: obj.$modal,
              paperId: addPaperId, 
              categoryMid: null,
              groupId:  obj.groupId,
              projectId: obj.projectId,
              projectName: obj.projectName,
              paperTitle: "",
              contentPath: "",
              docGrade: String(obj.projectInfo.cogroup.publicYn) == "1" ? "NORMAL" : "RESTRICT",
              component: RegistBoardModal,
              //localselectIidx: obj.localselectIidx,
              parentCategoryMid: this.parentCategoryMid
            };
            obj.showModal(modalInfo);
          })
          .catch(function(err) {
            console.log(err);
          });
      },
      updateCommonFilterB(filterData) {
        this.categoryMidList = filterData.filterCategoryMidList;
        this.gradeCodeList = filterData.filterGradeList;
        this.statusList = filterData.filterStatusList;
        this.categoryCheckYn = filterData.categoryCheckYn;
        this.gradeCheckYn = filterData.gradeCheckYn;
        this.statusCheckYn = filterData.statusCheckYn;

        this.updatedList=[];
        this.currentPage=0;
        this.totalPage =0;
        this.currentIndex=0;
        this.totalElements =0;
        this.historyDates=[];
        this.getHistoryDate(this.groupId);
      }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/detail/tab/history/DashboardHistory.vue